import { useState } from "react";

import LoadingSpinner from "../../images/loading_gray.gif";
import Modal from "../Modal/Modal";
import { Container, MainButton } from "./AdminAskForActionStyles";

function AdminAskForAction(props: any) {
  const {
    toggleModal,
    onApprove,
    hideSidebar,
    titleMessage,
    bodyMessage,
    buttonMessage,
  } = props;
  const [waitingForServerResponse, updateWaitingForServerResponse] =
    useState(false);

  return (
    <Modal
      onOutsideClick={() => {
        toggleModal();
      }}
    >
      <Container>
        <h1>{titleMessage}</h1>
        <p>{bodyMessage}</p>
        <MainButton
          onClick={() => {
            if (waitingForServerResponse) return;
            updateWaitingForServerResponse(true);
            onApprove()
              .then(() => {
                updateWaitingForServerResponse(false);
                toggleModal();
                hideSidebar();
              })
              .catch(() => updateWaitingForServerResponse(false));
          }}
          disabled={waitingForServerResponse}
        >
          {waitingForServerResponse && (
            <img className="icon" src={LoadingSpinner} alt="spinner" />
          )}
          {buttonMessage}
        </MainButton>
      </Container>
    </Modal>
  );
}
export default AdminAskForAction;
